export default "__VITE_ASSET__DRWsU$ih__"